import React from 'react';
import { I2cAlert } from '@webcomponents/i2cwebcomponents/dist/react';

/**
 * Toast configuration for different variants
 */
const TOAST_CONFIG = {
  success: {
    variant: 'success',
    headerArt: 'linear-tick-circle',
    duration: '4000',
  },
  error: {
    variant: 'danger',
    headerArt: 'linear-info-circle',
    duration: '5000',
  },
  warning: {
    variant: 'warning',
    headerArt: 'linear-folder',
    duration: '4000',
  },
  info: {
    variant: 'neutral',
    headerArt: 'cs-linear-codepen',
    duration: '4000',
  },
};

const ToastContainer = ({ 
  successAlertRef, 
  errorAlertRef, 
  warningAlertRef, 
  infoAlertRef,
  toastMessage 
}) => {
  const toasts = [
    { ref: successAlertRef, type: 'success' },
    { ref: errorAlertRef, type: 'error' },
    { ref: warningAlertRef, type: 'warning' },
    { ref: infoAlertRef, type: 'info' },
  ];

  return (
    <>
      {toasts.map((toast, index) => {
        if (!toast.ref) return null;
        
        const config = TOAST_CONFIG[toast.type];
        
        return (
          <I2cAlert 
            key={index}
            ref={toast.ref} 
            variant={config.variant} 
            duration={config.duration} 
       
            headerArtStyle="shadowed" 
            layout="layoutAsideLeft" 
            placement="top-end" 
            type="plain" 
            closable
          >
            
            <p>{toastMessage.description}</p>
          </I2cAlert>
        );
      })}
    </>
  );
};

export default ToastContainer;
